export default function getLocalStorage(key) {
    return localStorage.getItem(key);
}
